import moment from "moment-timezone";

export const convertDateToUserTimezone = (
  userTimezone: string | null = undefined,
  date: string | null = undefined,
) => {
  const timezone =
    userTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

  // let returnValue = moment.tz(timezone).toISOString();
  let returnValue = moment.tz(timezone).format(date);
  if (date) {
    // returnValue = moment.tz(date, timezone).toISOString();
    returnValue = moment.tz(date, timezone).format();
  }

  return returnValue;
};
